import { TRAFFIC_LIGHT_COLOURS, activityAssessmentsLegend } from '@src/modules/performance/shared/constants';
import { selectedDatabaseIdState, useIsUserInRole } from '@transport-insights/uikit';
import { Text } from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';
import Widget from './Widget';
import { CircleIndicator } from '../indicators';
import IndicatorLegend from '../IndicatorLegend';
import { usePlanningQuality } from '../../context/reports-api-hooks';

export default function ActivityManagementWidget() {
  const { data: activityManagementData, isLoading, isError } = usePlanningQuality();
  const rcaId = useRecoilValue(selectedDatabaseIdState);
  const hasDeveloperRole = useIsUserInRole('Developer');

  const title = 'Activity Management';
  const description = 'Planning quality\nout of 3.00';

  // Only allow access to RCAs excluding State Highways
  // unless user has Developer role
  if ((rcaId === 81 || rcaId >= 1000) && !hasDeveloperRole) {
    return null;
  }

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/activity-management"
      title={title}
      description={description}
      lockYear="2024-27"
      quarter={null}
      isLoading={isLoading && !activityManagementData}
      moreInfoContent={(
        <>
          <Text fontSize="sm" mb={2}>
            The result of an independent assessment by Road Efficiency Group Te Ringa Maimoa of the TA&rsquo;s Transport Activity Management Plan (AMP) submitted to NZTA.
          </Text>
          <Text fontSize="sm" mb={2}>
            AMPs are assessed against elements of the &quot;Road Efficiency Group Te Ringa Maimoa Pillars of Success&quot; framework including Systems, Evidence, Communicating, Decision Making, Service Delivery and Improvement Plan.
          </Text>
          <Text fontSize="sm" mb={2}>
            The assessment consists of 23 attributes scored 0 to 3. The result displayed is an average of the attribute scores.
          </Text>
          <Text fontSize="sm" mb={2}>
            The average attribute result colour grading is as follows:
          </Text>
          <IndicatorLegend items={activityAssessmentsLegend} />
          <Text fontSize="xs" mt={2}>
            Source: Assessment, results and grading provided by Road Efficiency Group Te Ringa Maimoa.
          </Text>
        </>
      )}
    >
      <CircleIndicator
        size={100}
        colour={TRAFFIC_LIGHT_COLOURS[activityManagementData?.colour]}
        value={activityManagementData?.value?.toFixed(2)}
        isLoading={isLoading && !activityManagementData}
      />
    </Widget>
  );
}
